// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hn","advertCardPhoto__image":"c-a_ho"};